import CreateAccount from './CreateAccount'
import enhance from './CreateAccount.enhancer'

export default enhance(CreateAccount)



// WEBPACK FOOTER //
// ./src/containers/account/CreateAccount/index.js